import { WebStorageStateStore, type UserManagerSettings } from 'oidc-client-ts';
import type { AuthProviderProps } from 'react-oidc-context';

const browserOrigin = window.location.origin;

export const cognitoAuthConfig: UserManagerSettings & Pick<AuthProviderProps, 'onSigninCallback'> = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY!,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID!,
  redirect_uri: `${browserOrigin}/callback`,
  post_logout_redirect_uri: browserOrigin,
  response_type: 'code',
  scope: 'email openid phone',
  automaticSilentRenew: true,
  stateStore: new WebStorageStateStore({ store: window.localStorage, prefix: 'mcc.oidc.' }),
  userStore: new WebStorageStateStore({ store: window.localStorage, prefix: 'mcc.user.' }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, '/dashboard');
  },
};
